import React from "react";
import { Link, useLocation } from "react-router-dom";

function NotFound() {
  const location = useLocation();
  const isSpanish = location.pathname.startsWith("/es");

  const text = isSpanish
    ? {
        title: "404",
        message: "Esta página se perdió camino al estudio",
        button: "Volver al inicio",
        home: "/es",
      }
    : {
        title: "404",
        message: "This page got lost on the way to the studio",
        button: "Back to Home",
        home: "/en",
      };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{ backgroundColor: "#0A0A0A" }}
    >
      <h1
        className="font-heading leading-none select-none"
        style={{
          fontSize: "clamp(8rem, 20vw, 16rem)",
          color: "#E07020",
          lineHeight: 1,
        }}
      >
        {text.title}
      </h1>

      <p
        className="mt-4 text-lg md:text-xl max-w-md"
        style={{ color: "#A0A0A0" }}
      >
        {text.message}
      </p>

      <Link
        to={text.home}
        className="mt-10 inline-block px-8 py-3 rounded-full text-sm font-semibold uppercase tracking-widest transition-all duration-300"
        style={{
          border: "2px solid #E07020",
          color: "#E07020",
          backgroundColor: "transparent",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#E07020";
          e.currentTarget.style.color = "#0A0A0A";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
          e.currentTarget.style.color = "#E07020";
        }}
      >
        {text.button}
      </Link>
    </div>
  );
}

export default NotFound;
